import { ZSidLabel } from "src/types";

import { loadSpecification } from "../specification";
import { makeRowEvaluate } from "../specification/rowEvaluate";
import {
  loadValueCatalog,
  valueCatalogCardsLoader,
} from "../valueCatalog/apiValueCatalog";
import { ZOptionsMaker, ZOptionsValuesCatalog } from "./ZOptionsMaker";

/* eslint consistent-return: "off" */

/**
 * Формирование списка опций для AttrEditSelect
 * @param maker
 * @returns
 */
export const makeAttrSelectOptions = async (
  maker: ZOptionsMaker,
): Promise<ZSidLabel[]> => {
  // Компилятор должен выдавать ошибку, если появится новый способ формирования опций
  // eslint-disable-next-line default-case
  switch (maker.type) {
    case "inline":
      return maker.list;
    case "valuesCatalog":
      return makeValuesCatalogOptions(maker);
  }
};

const makeValuesCatalogOptions = async (
  def: ZOptionsValuesCatalog,
): Promise<ZSidLabel[]> => {
  const catalog = await loadValueCatalog(def.valuesCatalogId);
  const spec = await loadSpecification("values", catalog.schema.id);
  const loader = valueCatalogCardsLoader(def.valuesCatalogId, spec);
  const res = await loader({ page: 0, pageSize: 1000 });
  // TODO: пока не решён вопрос с максимально возможным количеством опций в списке
  const rowEval = makeRowEvaluate(def.labelTemplate, [spec]);
  const options: ZSidLabel[] = res.rows.map((row) => ({
    id: row.id,
    label: rowEval(row),
  }));
  return options;
};
